<template>
  <div>
    <Row class="icon-guiji" :gutter="16">
      <Col span="4" class="icon">
        <Icon @click="submit(1)" type="ios-play" v-if="$store.state.carMsg.play==1" />
        <Icon @click="submit(2)" type="ios-pause" v-if="$store.state.carMsg.play==2" />
        <Icon @click="submit(3)" type="ios-play" v-if="$store.state.carMsg.play==3" />
      </Col>
      <Col span="12">
        <Slider v-model="speed" :min="0" :max="100" style="width:100%" @on-change="changeSlider"></Slider>
      </Col>
      <Col span="8">
        <Select v-model="model1" @on-change="changeSpeed" style="width:100%">
          <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cityList: [
        {
          value: "1",
          label: "一档"
        },
        {
          value: "5",
          label: "二档"
        },
        {
          value: "10",
          label: "三档"
        },
        {
          value: "15",
          label: "四档"
        },
        {
          value: "20",
          label: "五档"
        }
      ],
      model1: "5",
      speed: 0, //滑块速度
      hideFormat() {
        return null; //隐藏滑块标签
      }
    };
  },
  methods: {
    //点击回放轨迹按钮
    submit(m) {
      if (m == 1) {
        this.$store.state.carMsg.play = 2;
      } else if (m == 2) {
        this.$store.state.carMsg.play = 3;
      } else if (m == 3) {
        this.$store.state.carMsg.play = 2;
      }
      this.$emit("parentFn", m);
    },
    //点击速度选择
    changeSpeed(v) {
      this.$emit("changeSpeed", v);
    },
    //拖动滑块时候
    changeSlider(v) {
      this.$emit("changeSlider", v);
    },
    //车辆移动时候滑块改变
    changeCurentPoint(v, length) {
      this.speed = Number((v * 100) / (length - 1));
      //this.speed = v;
    }
  },
  mounted() {
    
  },
};
</script>
<style lang="">
.icon-guiji {
  padding: 10px 15px;
}

.icon-guiji .icon i {
  font-size: 1.8em;
  padding: 0.3em;
  border-radius: 1em;
  color: #7096ff;
}
.icon-guiji .icon i:hover {
  background: #e2eafd;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/play.vue